<script setup lang="ts">
  import { computed } from 'vue';

  import type { TaskRequirement, TaskRequirementOption } from '@stuut/api/models';

  import TaskRequirementApproveReject from './TaskRequirementApproveReject.vue';
  import TaskRequirementDateInput from './TaskRequirementDateInput.vue';
  import TaskRequirementEntityInput from './TaskRequirementEntityInput.vue';
  import TaskRequirementFileInput from './TaskRequirementFileInput.vue';
  import TaskRequirementTextInput from './TaskRequirementTextInput.vue';

  const props = defineProps<{
    requirement: TaskRequirement;
    saving?: boolean;
    partnerId?: string;
    isTaskOpen?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'approve'): void;
    (e: 'reject'): void;
    (e: 'dismiss'): void;
    (e: 'resolve', value: string): void;
    (e: 'selectOption', option: TaskRequirementOption): void;
  }>();

  const hasOptions = computed(() => !!props.requirement.options?.length);
  const inputType = computed(() => props.requirement.input_type);
  const isTextInput = computed(
    () => !['approve_reject', 'date', 'entity', 'file'].includes(inputType.value),
  );
  const wrapperDisabled = computed(() => (!props.isTaskOpen || props.saving) && !isTextInput.value);
</script>

<template>
  <div
    class="flex items-center gap-2.5 ml-5 flex-wrap w-full md:w-140 max-w-160 transition-opacity"
    :class="wrapperDisabled && 'pointer-events-none opacity-50'"
    :aria-disabled="wrapperDisabled || undefined"
  >
    <!-- <TaskRequirementOptions
      v-if="hasOptions"
      :requirement="requirement"
      @select-option="(opt) => emit('selectOption', opt)"
      @resolve="(val) => emit('resolve', val)"
    /> -->

    <TaskRequirementApproveReject
      v-if="inputType === 'approve_reject'"
      @approve="emit('approve')"
      @reject="emit('reject')"
    />

    <TaskRequirementFileInput
      v-else-if="inputType === 'file'"
      :requirement="requirement"
      @resolve="(val) => emit('resolve', val)"
    />

    <TaskRequirementDateInput
      v-else-if="inputType === 'date'"
      :val="requirement?.resolution?.value"
      @resolve="(val) => emit('resolve', val)"
    />

    <TaskRequirementEntityInput
      v-else-if="inputType === 'entity'"
      :requirement="requirement"
      :partner-id="partnerId"
      :val="requirement?.resolution?.value"
      @resolve="(val) => emit('resolve', val)"
    />

    <TaskRequirementTextInput
      v-else
      :val="requirement?.resolution?.value"
      :disabled="!isTaskOpen"
      @resolve="(val) => emit('resolve', val)"
    />

    <!-- <Button
      v-if="requirement.allow_dismiss"
      size="sm"
      variant="outline"
      :disabled="disabled || requirement.isDismissed"
      @click="emit('dismiss')"
    >
      Dismiss
    </Button> -->
  </div>
</template>
